var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifecell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8101_101435)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.146484 7.75879C0.146484 3.90879 3.24345 0.758789 7.10406 0.758789C10.9647 0.758789 14.0616 3.90879 14.0616 7.75879C14.0616 11.6088 10.9647 14.7588 7.10406 14.7588C6.34042 14.7588 5.61921 14.6275 4.94042 14.4088C5.44951 11.5213 7.23133 9.15879 9.64952 8.15254C9.94648 8.50254 10.3707 8.67754 10.8374 8.67754C11.6859 8.67754 12.3647 7.97754 12.3647 7.10254C12.3647 6.22754 11.6859 5.52754 10.8374 5.52754C9.98891 5.52754 9.31012 6.22754 9.31012 7.10254C6.25558 8.02129 3.79497 10.165 2.52224 12.9213C2.14042 12.5713 1.75861 12.1775 1.46164 11.6963C1.54648 9.02754 2.86164 6.66504 4.81315 5.26504C5.11012 5.61504 5.53436 5.79004 5.95861 5.79004C6.80709 5.79004 7.48588 5.09004 7.48588 4.21504C7.48588 3.34004 6.80709 2.64004 5.95861 2.64004C5.11012 2.64004 4.43133 3.34004 4.43133 4.21504C4.43133 4.25879 4.43133 4.30254 4.43133 4.34629C2.60709 5.00254 1.07982 6.27129 0.188909 7.93379C0.146484 7.93379 0.146484 7.84629 0.146484 7.75879Z",
    fill: "#FCCF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8101_101435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.146484 0.758789)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifecell);
export default __webpack_public_path__ + "static/media/lifecell.50dd1e2cebb2968b91d99e2e14a7a063.svg";
export { ForwardRef as ReactComponent };